// extracted by mini-css-extract-plugin
export default {"Toggle":"VmcIlJWmbDMsgYfod9ki","DangerItem":"KVUndAvaduxE4Vt11WVM"};